import { useCallback, useEffect, useState } from "react";
import { useAuth } from "@clerk/react";
import { toast } from "sonner";
import { Eye, EyeOff } from "lucide-react";
import { Stars } from "../Stars";
import axios, { API, authed, errMsg, formatDate } from "../../lib/api";

export const ReviewsAdmin = ({ onChange }) => {
  const { getToken } = useAuth();
  const [list, setList] = useState([]);
  const [filter, setFilter] = useState("all");

  const load = useCallback(async () => {
    const r = await axios.get(`${API}/admin/reviews`, await authed(getToken));
    setList(r.data);
  }, [getToken]);
  useEffect(() => { load(); }, [load]);

  const toggle = async (r) => {
    try {
      await axios.patch(`${API}/admin/reviews/${r.id}`, { hidden: !r.hidden }, await authed(getToken));
      toast.success(r.hidden ? "Recenzia este din nou vizibilă." : "Recenzia a fost ascunsă.");
      load(); onChange();
    } catch (e) { toast.error(errMsg(e)); }
  };

  const shown = list.filter((r) => filter === "all" || (filter === "hidden" ? r.hidden : !r.hidden));
  const chip = (v, label) => (
    <button onClick={() => setFilter(v)} data-testid={`reviews-filter-${v}`}
      className={`rounded-full px-4 py-1.5 text-sm transition-colors ${filter === v ? "bg-white text-[#090E17]" : "border border-white/10 text-slate-400 hover:text-white"}`}>{label}</button>
  );

  return (
    <div>
      <div className="mb-5 flex gap-2">{chip("all", "Toate")}{chip("visible", "Vizibile")}{chip("hidden", "Ascunse")}</div>
      {shown.length === 0 && <p className="text-slate-500" data-testid="admin-reviews-empty">Nicio recenzie aici.</p>}
      <ul className="space-y-3" data-testid="admin-reviews-list">
        {shown.map((r) => (
          <li key={r.id} data-testid={`admin-review-row-${r.id}`} className={`rounded-2xl border border-white/[0.07] bg-[#131B26] p-4 ${r.hidden ? "opacity-55" : ""}`}>
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <p className="text-sm"><b>{r.author || "Client Anonim"}</b> <span className="text-slate-500">pentru</span> <b className="text-[#00F0FF]">{r.washer_name}</b></p>
                <div className="mt-1 flex items-center gap-2 text-xs text-slate-500"><Stars value={r.rating} size={12} /> {formatDate(r.created_at)}</div>
              </div>
              <button onClick={() => toggle(r)} data-testid={`toggle-review-visibility-${r.id}`}
                className="flex shrink-0 items-center gap-1.5 rounded-full border border-white/10 px-3 py-1.5 text-xs text-slate-300 hover:border-white/30">
                {r.hidden ? <><Eye size={14} /> Afișează</> : <><EyeOff size={14} /> Ascunde</>}
              </button>
            </div>
            {r.comment && <p className="mt-2 text-sm text-slate-300">{r.comment}</p>}
          </li>
        ))}
      </ul>
    </div>
  );
};
